import { PlanEligibilityStatus } from 'core/constants';
import { ModelBase } from 'store/model-base';

export class DataPlanBTG extends ModelBase {
    public planCode: string;
    public eligibilityStatus: PlanEligibilityStatus;
}